<div class="row p-2 ">
    <div class="col-sm-12 w-100">
        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


      

          
    
            <div class=" col-md-12 bg-dark p-2 mt-5 text-center rounded" data-toggle="collapse" href="#collapsecalendar" role="button"
            aria-expanded="false" aria-controls="collapseExample"  style="min-width: 48%;"  >
            <h4 class="text-white text-center p-1"  href="#collapsecalendar" role="button"
            aria-expanded="false" aria-controls="collapseExample" >Click to view schedules</h4>
            </div>
    <div class="collapse col-md-12 box box-primary rounded border-top border-primary shadow-sm bg-white"  id="collapsecalendar">
            
        <app-sales-rep-timetable></app-sales-rep-timetable>
        
      <!--  <mwl-demo-utils-calendar-header
                  [(view)]="view"
                  [(viewDate)]="viewDate"
                  (viewDateChange)="fetchEvents()"
                  (viewChange)="fetchEvents()"
                >
                </mwl-demo-utils-calendar-header>
                
                <ng-template #loading>
                  <div class="text-center">
                    <i class="fas fa-spin fa-spinner fa-5x"></i> <br />
                    Loading events...
                  </div>
                </ng-template>
                
                <div *ngIf="events$ | async; else loading; let events">
                  <div [ngSwitch]="view">
                    <mwl-calendar-month-view
                      *ngSwitchCase="'month'"
                      [viewDate]="viewDate"
                      [events]="events"
                      [activeDayIsOpen]="activeDayIsOpen"
                      (dayClicked)="dayClicked($event.day)"
                      (eventClicked)="eventClicked($event.event)"
                    >
                    </mwl-calendar-month-view>
                    <mwl-calendar-week-view
                      *ngSwitchCase="'week'"
                      [viewDate]="viewDate"
                      [events]="events"
                      (eventClicked)="eventClicked($event.event)"
                    >
                    </mwl-calendar-week-view>
                    <mwl-calendar-day-view
                      *ngSwitchCase="'day'"
                      [viewDate]="viewDate"
                      [dayStartHour]="8"
                      [dayEndHour]="18"
                      [events]="events"
                      (eventClicked)="eventClicked($event.event)"
                    >
                    </mwl-calendar-day-view>
                  </div>
                </div>-->
    
            </div>
        
    
    








            <div class="jumbotron p-0" >
                <div class="container ">
                    <div class="row">
                        <div class="col-md-12 p-0 ">

                            <form [formGroup]="scheduleForm" class="text-center border border-light p-3">

                           

                                <div class="float-right w-100">
                                    <h3 class="float-left align-center py-3 text-danger"></h3> <div class="float-left py-4 text-danger" style="font-family:'DINPro'">* mandatory fields</div>
                                </div>
                                <br>
                                


                                <div class="row w-100 d-flex justify-content-between p-2">
                                    <div class="col-md-5 form-group py-2">
                                        <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Status</label>
                                        <select class="form-control select2tag select2-hidden-accessible"
                                            formControlName="status" id="status" name="status" style="width: 100%;"
                                            tabindex="-1" aria-hidden="true" [class.is-invalid]="formErrors.status"
                                            (blur)="logValidationErrors(scheduleForm)">
                                            <option value='0'>SELECT</option>
                                            <option value="In Progress">In Progress</option>
                                            <option value="Pending">Pending</option>
                                            <option value="Completed">Completed</option>
                                            <option value="Cancelled">Cancelled</option>
                                            
                                        </select>
                                        <div [class.d-none]="!formErrors.status">
                                            <small clas="text-danger">{{formErrors.status}}</small></div>
                                    </div>
    
    
    
                                    </div>
    

                                    

                                
                                <div class="row w-100 d-flex justify-content-between">
                                 
     
     
                                     <div class="col-md-5 form-group py-2 ">
                                       
                                         <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Pick Up Time</label>
                                         <app-date-time-picker  formControlName="pickupTime"  name="pickupTime"></app-date-time-picker>   
     
                                     </div>
     
     
                                     
                                     <div class="col-md-5 form-group py-2 mx-1">
                                       
                                        <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Check Out</label>
                                        <app-date-time-picker  formControlName="checkOut"  name="checkOut"></app-date-time-picker> 
    
                                    </div>
                                 </div>



                                <div class="row w-100 d-flex justify-content-between p-2">
                               <div class="col-md-5 form-group py-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100 " style="font-family:'DINPro'">Full
                                        Name<i class="text-danger ">*</i></label>
                                    <input type="text" formControlName="fullName" class="form-control "
                                        [class.is-invalid]="formErrors.fullName"
                                        (blur)="logValidationErrors(scheduleForm)" />

                                    <div [class.d-none]="!formErrors.fullName">
                                        <small class="text-danger">{{formErrors.fullName}}</small></div>
                                </div>



                                <div class="col-md-5 form-group py-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Email</label>
                                    <input type="text" formControlName="email" class="form-control"
                                        [class.is-invalid]="formErrors.email"
                                        (blur)="logValidationErrors(scheduleForm)" />

                                    <div [class.d-none]="!formErrors.email">
                                        <small>{{formErrors.email}}</small></div>

                                </div>


                            </div>




                            <div class="row w-100 d-flex justify-content-between p-2">
                                <div class="col-md-5 form-group py-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Phone
                                        Number</label>
                                    <input type="text" formControlName="phoneNumber" class="form-control"
                                        [class.is-invalid]="formErrors.phoneNumber"
                                        />

                                    
                                </div>




                            </div>




                    

                            
                            <div class="row w-100 d-flex justify-content-between p-2" >
                             
                                <div class="col-md-5  form-group py-2">
                                    <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Please select location for appointment?<i class="text-danger ">*</i></label>
                                    <select class="form-control select2tag select2-hidden-accessible"
                                        formControlName="branch" id="branch" name="branch"
                                        style="width: 100%;" tabindex="-1" aria-hidden="true" (change)='getSalesRep($event.target.value)'
                                   >
                                      
                                        <option *ngFor='let branch of branchs' value={{branch}}>{{branch}}</option>
                                    
                                    </select>


                                </div>
                             
                                <div class="col-md-5 form-group py-2" *ngIf='branchselected'>
                                <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Sales Representative</label>
                                <select class="form-control select2tag select2-hidden-accessible"
                                    formControlName="salesRepID" id="salesRepID" name="salesRepID"
                                    style="width: 100%;" tabindex="-1" aria-hidden="true"
                                    
                                    (blur)="logValidationErrors(scheduleForm)">
                                    <!--<option value='0'>SELECT</option>-->
                                    <option *ngFor='let rep of salesRep' value={{rep.userID}}>{{rep.fullName}}
                              
                                </select>

                            </div>

                        </div>
                 

                        <div class="form-group p-2">
                            <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Order Description</label>
                            <textarea type="text" formControlName="orderDescription" class="form-control"> </textarea>

                        </div>



                            <div class="form-group p-2">
                            <label class="text-left font-weight-bold p-2 rounded w-100" style="font-family:'DINPro'">Notes</label>
                            <textarea type="text" formControlName="notes" class="form-control"> </textarea>

                        </div>








                                <div class="form-group m-2 text-center d-flex flex-column ">
                                
                  
                                    <div class="text-center"><button 
                                            [disabled]='!scheduleForm.valid || !scheduleForm.valid'
                                            data-toggle="modal" (click)=onSubmit() class="btn  text-dark "
                                            style="align-content: center;  background: white;"><i
                                                class="fa fa-check"></i>
                                            Submit</button>
                                    </div>

                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>










        </div>
    </div>
</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                        Success Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openSuccessModalButton" [hidden]="true" data-toggle="modal" data-target="#SuccessModal">Open Modal</button>
<!-- Modal -->
<div id="SuccessModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

           <!-- <h4 class="modal-title text-success">SUCCESS</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>-->
            </div>
            <div class="modal-body " style="background: black;">
                <div class="row p-5 ">
                    <div class="col-sm-12 w-100">
                        <div class="d-flex flex-column justify-content-between  row w-100 m-0">


                            <img class="px-3"
                                style="display: block; margin-right: auto; margin-left: auto; max-height: 100px; max-width: 200px;"
                                src="./assets/logo2020w.png" />

                            <div class="w-100 text-center">
                                <h3 class="bg-black text-white pt-4" style="font-family:'DINPro';">THANK YOU </h3>
                            </div>

                            <div class="border  bg-white "></div>
                            <div class="w-100 text-center">
                                <h4 class="bg-black text-white pt-4" style="font-family:'DINPro';">Appointment has been saved.</h4>
                            </div>



                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default text-center" routerLink='/logistics-main' data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>
</div>


<!------------------------------------------------------------------------------------------------------------------------------------------
                       Error Modal
                    ------------------------------------------------------------------------------------------------------------------------------------------>
<button id="openErrorModalButton" [hidden]="true" data-toggle="modal" data-target="#ErrorModal">Open Modal</button>
<!-- Modal -->
<div id="ErrorModal" class="modal fade" role="dialog">
    <div class="modal-dialog">

        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">

                <h4 class="modal-title text-danger">ERROR</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body text-danger">
                <p>{{error}}</p>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" routerLink='/logistics-main' data-dismiss="modal">Close</button>
            </div>
        </div>

    </div>